'use client'

import { InfoBanner, Spacer, Text } from '@vinted/web-ui'
import { useInView } from 'react-intersection-observer'

import {
  ItemPageInfoBannerModel,
  itemPageViewEvent,
} from '@marketplace-web/item-page/item-page-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'

const InfoBannerPlugin = ({
  level,
  title,
  body,
  pluginName,
  item_id,
}: ItemPageInfoBannerModel & { pluginName: string }) => {
  const { track } = useTracking()
  const { ref } = useInView({
    onChange: inView => {
      if (!inView) return
      track(
        itemPageViewEvent({
          item_id: item_id.toString(),
          target: 'high_demand',
        }),
      )
    },
    triggerOnce: true,
  })

  return (
    <div ref={ref}>
      <Spacer size="large" />
      <InfoBanner
        body={body && <Text as="span" text={body} html type="subtitle" theme="amplified" />}
        title={title}
        testId={`${pluginName}-info-banner`}
        type={level}
        styling="tight"
      />
      <Spacer />
    </div>
  )
}

export default InfoBannerPlugin
